import { ColorSchemeContext } from "@/lib/contexts";
import { ColorSchemeContextType } from "@/lib/types";
import { useContext } from "react";

export default function useColorScheme(): ColorSchemeContextType {
  const context = useContext(ColorSchemeContext);
  if (!context) {
    throw new Error(
      "useColorScheme must be used within a ColorSchemeContext.Provider",
    );
  }
  return context;
}
